// extracted by mini-css-extract-plugin
export var notificationHost = "_mi-0";